import { useTranslation } from "react-i18next"
import PageLayout from "components/layout/PageLayout"
import { ColorPicker } from 'primereact/colorpicker';
import { useEffect, useState } from "react";
import { useEditRoleMutation, useGetCompanyRolesQuery } from "./api/companyRolesApiSlice";
import { useLocation } from "react-router-dom";
import SuccessMessage from "components/commons/SuccessMessage";

const RoleEdit = () => {

    const [t] = useTranslation(["global"])

    let location = useLocation()

    console.log("Location: " + JSON.stringify(location))

    let editingRoleGUID = location.state ? location.state.roleGUID : "ffedb918-17cc-4626-9740-228df0ec11aa"

    const [name, setName] = useState("Role");
    const [desc, setDesc] = useState("Desc");
    const [backColor, setBackColor] = useState("ffffff");
    const [foreColor, setForeColor] = useState("000000");




    const {
        data: rolesWithPermissions,
        isFetching: rolesIsFetching,
        isSuccess: rolesIsSuccess,
        isError: rolesIsError,
        error: rolesError,
        refetch: rolesRefetch
    } = useGetCompanyRolesQuery()

    const [
        editRequest, {
            data: roleEditResult,
            isLoading: roleEditLoading,
            isSuccess: roleEditSuccess,
            reset: roleEditReset
        }
    ] = useEditRoleMutation()

    const handleSubmit = async (e) => {
        e.preventDefault()

        const payload = {
            guid: editingRoleGUID,
            name: name,
            description: desc,
            backgroundColor: `#${backColor}`,
            textColor: `#${foreColor}`,
        }

        console.log("Payload: " + JSON.stringify(payload))
        editRequest(payload)

    }


    useEffect(() => {
        if (rolesIsSuccess) {

            // FINDING ORIGINAL ROLE DATA
            let role = rolesWithPermissions.find(roleWithPerm => roleWithPerm.role.guid == editingRoleGUID).role

            // FILLING COMPONENTS PROPS (for filling UI fields)
            setName(role.name)
            setDesc(role.description)
            setBackColor(role.backgroundColor.replace("#", ""))
            setForeColor(role.textColor.replace("#", ""))
        }

    }, [rolesIsSuccess])

    let content

    content = (
        <>
            <div className="row">

                {
                    roleEditSuccess &&
                    <SuccessMessage />
                }
                <div className="col-md-8 order-md-1">

                    <form onSubmit={handleSubmit}>
                        <div className="col-md-6 mb-3">
                            <label htmlFor="roleName">{t("property.name")}</label>
                            <input type="text" className="form-control" id="roleName" value={name} onChange={(e) => setName(e.target.value)} placeholder="" required />
                            <div className="invalid-feedback">
                                Valid role name is required.
                            </div>
                        </div>


                        <div className="mb-3">
                            <label htmlFor="roleDescription">{t("property.description")}</label>
                            <div className="input-group">
                                <input type="text" className="form-control " id="roleDescription" value={desc} onChange={(e) => setDesc(e.target.value)} required />
                                <div className="invalid-feedback">
                                    Valid role description is required.
                                </div>
                            </div>
                        </div>


                        <div className="row mt-5">

                            <div className="col-md-6 mb-3">
                                <h4 className="text-accent">{t("title.colors")}</h4>
                                <label htmlFor="color_text">{t("title.color_text")}</label><br />
                                <ColorPicker className="mb-2" value={foreColor} onChange={(e) => setForeColor(e.value)} /><span className="ms-2 small text-muted">#{foreColor}</span> <br />
                                <label htmlFor="color_background">{t("title.color_background")}</label><br />
                                <ColorPicker value={backColor} onChange={(e) => setBackColor(e.value)} /><span className="ms-2 small text-muted">#{backColor}</span> <br />

                            </div>

                            <div className="col-md-6 mb-3">
                                <h4 className="text-accent">{t("title.preview")}</h4>
                                <div className="card bg-dark">
                                    <div className="card-body">


                                        <span className="badge " style={{ backgroundColor: `#${backColor}`, color: `#${foreColor}`, padding: "10px" }}>{name.toUpperCase()}</span>
                                        <p className="text-muted small mt-2">{desc}</p>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <hr className="mb-3" />

                        <button className="btn mb-3 btn-primary btn-lg btn-block"><i className="fa-solid fa-floppy-disk"></i> {t("action.save")}</button>

                    </form>
                </div>
            </div>

        </>
    )


    return <PageLayout
        pageTitle={t("menu.edit_role")}
        isLoadingContent={rolesIsFetching}
        isLoadingPage={roleEditLoading}
        onPageRefresh={rolesRefetch}
        bodyContent={content}
    />
}

export default RoleEdit